module.exports = __webpack_public_path__ + "static/media/ecommerce.12e4fb63.svg";